import { Controller } from "@hotwired/stimulus";

// "Lägg till/Ta bort flygbolagsbonusnr" -- shows or hides every traveler's
// bonuscard select+number fields at once (class-based in the old jQuery
// version, target-based here). Scoped to the whole form.
export default class extends Controller {
  static targets = ["field", "addLink", "removeLink"];

  toggle(event) {
    event.preventDefault();
    const showing = this.fieldTargets.some((el) => !el.classList.contains("hidden"));

    this.fieldTargets.forEach((el) => {
      el.classList.toggle("hidden", showing);
      if (showing) {
        el.querySelectorAll("select").forEach((select) => { select.value = ""; });
      }
    });

    if (this.hasAddLinkTarget) this.addLinkTarget.classList.toggle("hidden", !showing);
    if (this.hasRemoveLinkTarget) this.removeLinkTarget.classList.toggle("hidden", showing);
  }
}
